import { render } from "./Comisiones.vue?vue&type=template&id=5de3eb08&scoped=true"
import script from "./Comisiones.vue?vue&type=script&lang=ts"
export * from "./Comisiones.vue?vue&type=script&lang=ts"

import "./Comisiones.vue?vue&type=style&index=0&id=5de3eb08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5de3eb08"

export default script